import BaseService from './Base.Service';

class PaymentScheduleService extends BaseService {
  constructor() {
    super('payment-schedules');
  }

  /**
   * Busca próximos pagamentos
   * @param {number} limit - Limite de resultados
   * @param {string} status - Filtro por status
   * @returns {Promise}
   */
  async getUpcoming(limit = 50, status = null, scope = null) {
    try {
      let url = `/${this.path}/upcoming?limit=${limit}`;
      if (scope) url += `&scope=${scope}`;
      if (status) {
        url += `&status=${status}`;
      }
      
      const response = await this.conn.axios.get(url);
      return response.data;
    } catch (err) {
      return this.sendError('Erro ao buscar próximos pagamentos', 400, err);
    }
  }

  /**
   * Gera cronogramas para um contrato
   * @param {number} contractId - ID do contrato
   * @param {number} startMonth - Mês inicial (1-12)
   * @param {number} startYear - Ano inicial
   * @param {number} endMonth - Mês final (1-12) 
   * @param {number} endYear - Ano final
   * @returns {Promise}
   */
  async generate(contractId, startMonth, startYear, endMonth = null, endYear = null) {
    try {
      const data = {
        contract_id: contractId,
        start_month: startMonth,
        start_year: startYear,
      };

      if (endMonth) data.end_month = endMonth;
      if (endYear) data.end_year = endYear;

      const response = await this.conn.axios.post(`/${this.path}/generate`, data);
      return response.data;
    } catch (err) {
      return this.sendError('Erro ao gerar cronogramas', 400, err);
    }
  }

  /**
   * Atualiza status de um cronograma
   * @param {number} id - ID do cronograma
   * @param {string} status - Novo status (PENDING, PAID, OVERDUE, CANCELLED)
   * @param {Object} additionalData - Dados adicionais (payment_date, actual_value, notes)
   * @returns {Promise}
   */
  async updateStatus(id, additionalData = {}) {
    try {
      const response = await this.conn.axios.put(`/${this.path}/${id}/status`, additionalData);
      return response.data;
    } catch (err) {
      return this.sendError('Erro ao atualizar status', 400, err);
    }
  }

  /**
   * Recalcula valor esperado de contrato HOURLY com base nas horas aprovadas
   * @param {number} id - ID do cronograma
   * @returns {Promise}
   */
  async exportAll(queryString = '') {
    try {
      const response = await this.conn.axios.get(`/${this.path}/export?${queryString}`);
      return response.data;
    } catch (err) {
      return this.sendError('Erro ao exportar cronogramas', 400, err);
    }
  }

  async recalculateHourly(id) {
    try {
      const response = await this.conn.axios.post(`/${this.path}/${id}/recalculate-hourly`);
      return response.data;
    } catch (err) {
      return this.sendError('Erro ao recalcular horas', 400, err);
    }
  }

  /**
   * Edita um cronograma (vencimento, valor esperado, observações)
   * @param {number} id - ID do cronograma
   * @param {Object} data - Campos editáveis (due_date, expected_value, notes)
   * @returns {Promise}
   */
  async updateSchedule(id, data = {}) {
    try {
      const response = await this.conn.axios.put(`/${this.path}/${id}`, data);
      return response.data;
    } catch (err) {
      return this.sendError('Erro ao atualizar cronograma', 400, err);
    }
  }

  /**
   * Exclui um cronograma (apenas pendente e sem nota fiscal)
   * @param {number} id - ID do cronograma
   * @returns {Promise}
   */
  async remove(id) {
    try {
      const response = await this.conn.axios.delete(`/${this.path}/${id}`);
      return response.data;
    } catch (err) {
      return this.sendError('Erro ao excluir cronograma', 400, err);
    }
  }
}

export default PaymentScheduleService;
